// format-prices-cents.js
(function () {
  const GRID_SEL  = '#amend-search-grid';
  const PRICE_SEL = '#amend-search-grid a div[style*="font-weight: bold"]';

  function digitsToEuro(dirty) {
    // Nur Ziffern behalten
    const digits = (dirty.match(/\d+/g) || []).join('');
    if (!digits) return null;

    // Komma zwei Stellen nach links
    let left, cents;
    if (digits.length === 1) { left = '0'; cents = '0' + digits; }
    else if (digits.length === 2) { left = '0'; cents = digits; }
    else { left = digits.slice(0, -2); cents = digits.slice(-2); }

    // Tausenderpunkte im linken Teil
    left = left.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${left},${cents}€`;
  }

  function formatPriceNode(el) {
    if (!el || el.dataset.priceFmt === '1') return;

    const raw = (el.textContent || '').trim();
    if (!raw) return;

    const formatted = digitsToEuro(raw);
    if (!formatted) { el.dataset.priceFmt = '1'; return; }

    el.textContent = formatted;       // z. B. "34,95€"
    el.dataset.priceFmt = '1';
  }

  function formatAllPrices() {
    document.querySelectorAll(PRICE_SEL).forEach(formatPriceNode);
  }

  function setup() {
    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    // Initial
    formatAllPrices();

    // Auf Änderungen im Live-Grid reagieren (ohne Endlosschleife)
    const observer = new MutationObserver(() => {
      observer.disconnect();
      requestAnimationFrame(() => {
        formatAllPrices();
        observer.observe(grid, { childList: true, subtree: true });
      });
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
